import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import globalReducer from './reducers';

export default configureStore({
  reducer: globalReducer,
  devTools: true,
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
});
